import { createExportContext } from './createExportContext';

import type {
  ExportMetaContextType,
  ExportPreviewContextType,
  ExportRequestContextType,
  ExportSettingsContextType
} from '../types/context.types';

export const { useContextHook: useExportSettings, Provider: ExportSettingsProvider } =
  createExportContext<ExportSettingsContextType>('ExportSettings');

export const { useContextHook: useExportPreview, Provider: ExportPreviewProvider } =
  createExportContext<ExportPreviewContextType>('ExportPreview');

export const { useContextHook: useExportRequest, Provider: ExportRequestProvider } =
  createExportContext<ExportRequestContextType>('ExportRequest');

export const { useContextHook: useExportMeta, Provider: ExportMetaProvider } =
  createExportContext<ExportMetaContextType>('ExportMeta');
